export const Container = ({ cust_class = '', children }) => (
  <div className={`container ${cust_class}`}>
    {children}
  </div>
);
